const initialState = {
    get: [], 
    image:[],
    
  
  };
  
  const AssistantProfileReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, get:action.payload};
            case 'FETCH_IMG_SUCCESS':
                return {... state, image:action.payload};  
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default AssistantProfileReducers;
  
  